import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/betprofessor/images/logo.svg';

export default function index() {
  return <Image src={logo} sx={{ maxW: ['166px', null, '215px'] }} />;
}
